
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.024 22.672L13.4 12.047a1.867 1.867 0 00-2.648 0l-1.766 1.765a1.867 1.867 0 000 2.649L16.51 24l-7.531 7.531a1.867 1.867 0 000 2.649l1.765 1.773a1.867 1.867 0 002.649 0l10.625-10.625a1.87 1.87 0 00.007-2.656zm15 2.656L28.4 35.953a1.867 1.867 0 01-2.648 0l-1.766-1.766a1.867 1.867 0 010-2.648L31.51 24l-7.531-7.531a1.867 1.867 0 010-2.649l1.765-1.773a1.867 1.867 0 012.649 0l10.625 10.625a1.87 1.87 0 01.007 2.656z","fill":"#535353"}})])
          )
        }
      }
    